<template>
  <div id="devServerContainer">
    <fractava-notes />
  </div>
</template>

<script>
export default {
	name: "DevServer",
	components: {
	}
};
</script>

<style>
#devServerContainer {
    width: 100%;
    height: 100%;
}
</style>
